const imagesList = [
    {
        image: "imageA.jpg",
    }, {
        image: "imageB.jpg",
    }, {
        image: "imageC.jpg",
    }, {
        image: "imageD.jpg",
    }, {
        image: "imageE.jpg",
    }, {
        image: "imageA.jpg",
    }, {
        image: "imageB.jpg",
    }, {
        image: "imageC.jpg",
    }, {
        image: "imageD.jpg",
    }, {
        image: "imageE.jpg",
    }]


export default imagesList;